import React from "react";
import {LoadingIndicator} from "./LoadingIndicator";

interface OverlayLoadingIndicatorProps {
    overlayClass?: string;
}

export let OverlayLoadingIndicator = function (props: OverlayLoadingIndicatorProps) {
    return (
        <div className={`loading-indicator-overlay ${props.overlayClass || ''}`}>
            <div className="loading-indicator-box">
                <LoadingIndicator/>
            </div>
        </div>
    );
};
